<template>
  <div class="universal" @keyup.enter="searchEnterFun">
    <!--面包屑-->
    <div class="crumbs">
      <!-- <span><router-link :to="{name:'Transition'}">首页</router-link></span> > -->
      <span>首页</span>>
      <span>本院影像</span>
    </div>
    <!--搜索框-->
    <div class="search">
      <div class="hospital-select">
        <div class="check-time">
          <em class="label">检查时间:</em>
          <el-radio-group v-model="checkDate" >
            <el-radio-button v-for="date in dates" :label="date" ></el-radio-button>
          </el-radio-group>
          <i>自定义</i>
          <pDate ref="child" @query="query" @ResetLable="ResetLable" ></pDate>
          <!-- <a href="javascript:;" @click="linkto" class="open-meeting s-btn">去开启会议 ></a> -->
        </div>
        <div class="check-type">
          <em class="label">检查类型:</em>
          <el-checkbox-group v-model="checkType">
            <el-checkbox-button v-model="checkType" value="" label="" key="所有" @change="handleCheckedAllchange">所有
            </el-checkbox-button>
            <el-checkbox-button v-for="check in checks" :label="check" :key="check" @change="handleCheckedChange">{{check}}</el-checkbox-button>
          </el-checkbox-group>
        </div>
        <div class="doc-type">
          <em class="label">就诊类别:</em>
          <el-checkbox-group v-model="checkDoc">
            <el-checkbox-button v-model="checkDoc" value="" label="" key="所有" @change="handleDocAllchange">所有
            </el-checkbox-button>
            <el-checkbox-button v-for="(doc,index) in docs" :label="doc" :key="doc" @change="handleDocChange">
              {{docslabel[index]}}
            </el-checkbox-button>
          </el-checkbox-group>
        </div>
        <ul class="district-type">
          <em class="label">选择医院:</em>
          <li>
            <el-select v-model="hosArea" @focus="hospitals" filterable   clearable placeholder="本院" class="image-input">
              <el-option

                v-for="item in hos"
                :key="item.hosId"
                :label="item.hosName"
                :value="item.hosId">
              </el-option>
            </el-select>
          </li>
          <li>
            <span>患者信息：</span>
            <el-input
              class="patientName"
              placeholder="患者姓名"
              v-model="patientName"
              clearable>
            </el-input>
            <el-input
              class="checkNumber"
              placeholder="患者编号/检查编号"
              v-model="checkNumber"
              clearable>
            </el-input>
          </li>
          <li >
            <!-- <span>报告标记：</span>
            <el-select
              class="biaoji"
              v-model="biaoji"
              multiple
              collapse-tags
              placeholder="全部">
              <el-option
                v-for="item in options"
                :key="item.catalogCode"
                :label="item.catalogName"
                :value="item.catalogCode">
              </el-option>
            </el-select> -->
            <el-checkbox v-model="checkRead">读片</el-checkbox>
          </li>
          <div class="search-box">
          <a href="javascript:;" class="reset" @click="reset">重置</a>
          <a href="javascript:;" class="search-btn s-btn" @click="getTime">查询</a>
          </div>
        </ul>
      </div>
    </div>
    <p-table :head="head" :data="data" :operation="operation" @_operation="_operation_"
             :dynamicOperationName="'operate'" :operationWidth="'130'" :autoheight="autoheight" v-loading="loading"></p-table>
    <page :total="totals" :allPage="allPages" :page-size="pageSize"  @page-size="__pageSize" :currentPage="currentPages" @current-page="pagequery"></page>

    <pops :show="pops" @closePop="closePop" :width="'860px'" :title="'收藏到病例库'" :classes="'Collections'" class="collect">
      <div slot="shoucang" :show="pops">
        <div class="record">
          <div class="record-left">
            <record v-if="pops" @tabChange="tabChange" :tabs="tabs" @changeColl="changeColl"
                    @delPerson="delPerson" @addPersonList="addPersonList" :showCheckBox="true"
                    :personList="personList" :treeData="treeData" @searchClick="searchClick"
                    :titleList="titleList" @checkTree="checkTree" @personChecked="personChecked"
                    :filterText="filterText">
            </record>
          </div>
          <div class="record-right" >
            <medicalNew :info="CaseInfo" @detailUpdate="CollectRecord"></medicalNew>
          </div>
        </div>
      </div>
      <div slot="shoucang-btn" :show="pops"><a href="javascript:;" class="shoucang" @click="Collect">收藏</a></div>
       <fullscreen :loadingText="loadingText" :isFullscreen="isFullscreen"></fullscreen>
    </pops>

    <aycanImages ref="aycanImages" :isBenYuan="true" :hospitalId='params_image.hospitalId' :studyPk='params_image.studyPk' :studyUid='params_image.studyUid' ></aycanImages>
    <!--<right-pops v-if="repShow">
      <router-view/>
    </right-pops>-->
  </div>

</template>

<script type="text/ecmascript-6">
  import pTable from '@/components/common/tables/publicTable'
  import page from '@/components/common/page/page'
  import pDate from '@/components/common/date/selectDate'
  import pops from '@/components/common/pops/pop'
  import record from '@/components/common/collapseMedicalRecord/collapseMedicalRecord'
  import medicalNew from '@/components/common/medicalNews/medicalNews/'
  //import rightPops from '@/components/common/right/rightPops'
  //import router from '../../../../router'
  import fullscreen from '@/components/common/base/fullscreen'//全屏遮罩
  import http from '@/api/http'
  import * as _ from '@/common/js/config'
  import {cookies} from '@/api/util'
  import {message} from '@/common/js/messages'
  import {nomalTime} from '@/common/js/time'
  import {changehosArea,changeAge,changeGender,changeSex,changeclinicType,changecheckType} from '@/common/js/change'

  import aycanImages from '@/components/common/base/aycanImages'

  const dates = ['今天', '近三天', '近一周', '近一月','近半年'];
  const checks = ['DX/DR/CR', 'CT', 'MR', 'RF', 'XA', 'US', 'ES'];
  const docslabel = ['门诊', '住院', '急诊', '体检' , '预约'];
  const docs = ['50', '10', '60', '70', '90'];

  export default {
    components: {
      pTable,
      page,
      pDate,
      pops,
      record,
      medicalNew,
      //rightPops,
      aycanImages,
      fullscreen
    },
    data() {
      return {
        hos:[],
        // hos: [{
        //   value: '',
        //   label: '本院'
        // },{
        //   value: '0',
        //   label: '解放院区'
        // },{
        //   value: '4',
        //   label: '滨江院区'
        // }],
         hosArea: '',    //默认全部院区 不能为空
        //hosArea:[],
        examStartDate: "",
        autoheight:this.getH(),
        examEndDate: "",
        checkDate: '今天',
        dates: dates,
        loading: false,
        checkType: [''],
        checks: checks,
        checkDoc: [''],
        hospitals:{
         hosId:'',
         hosName:'',
        },
        docs: docs,
        docslabel: docslabel,
        markCode:[''],
        checkRead: '',
        patientName: '',
        checkNumber: '',
        loadingblack:true,
        biaoji:[],
        options: [],
        //********table  固定项
        head: [
          {
            props: 'hospitalName',
            label: '医院名称',
            width: '10%'
          },
          {
            props: 'patientId',
            label: '患者编号',
            width: '8%'
          },{
            props: 'accessionNumber',
            label: '检查编号',
            width: '8%'
          },
          {
            props: 'examTypeName',
            label: '检查类型',
            width: '7%'
          },
          {
            props: 'patientName',
            label: '姓名',
            width: '6%'
          },
          {
            props: 'patientSex',
            label: '性别',
            width: '5%'
          },
          {
            props: 'patientAge',
            label: '年龄',
            width: '5%'
          },
          {
            props: 'clinicType',
            label: '就诊类别',
            width: '7%'
          },
          {
            props: 'examBodyName',
            label: '检查项目',
            width: '10%'
          },
          {
            props: 'examDate',
            label: '检查时间',
            width: '12%'
          }
        ],
        operation: [
          {
            operation: '',
            class: 'icon-baogao',
            class2: 'icon-baogao hui',
            title: '报告',
          },
          {
            operation: '',
            class: 'icon-yuepian',
            class2: 'icon-yuepian hui',
            title: '阅片'
          },
          {
            operation: '',
            class: 'icon-shoucang',
            class2: 'icon-yishoucang',
            title: '收藏'
          },
          {
            operation: '',
            class: 'icon-dupian',
            class2: 'icon-yidupian',
            title: '读片'
          }
        ],

        data: [],
        //*********收藏
        filterText: '',
        treeData: [],
        allTreeData: [],
        oldPersonList:[],
        tabs: [
          { label: "公共分类", name: "0" },
          { label: "个人分类", name: "1" }
        ],
        personList: [
          /*{ label: "个人病例1" },
          { label: "个人病例2" },
          { label: "个人病例3" }*/
        ],
        personCheckedList:[],
        defaultTreeChecked: [],
        defaultPersonListChecked: [],
        titleList: [
          { title: "自定义分类", name: "4" },
          { title: "按诊断分类", name: "1" },
          { title: "按部位分类", name: "2" },
          { title: "按科室分类", name: "3" }
        ],
        CaseInfo: {
          caseName: '',
          caseSex: '',
          caseAge: '',
          ageUnit: '',
          remark: '',
          history: '',
          caseResult: '',
          evidence: '',
          dianogeResult: '',
          index:'',
        },
        studyList:{},
        catalogId:'', //所属类型id
        privateType:0,//公开级别
        /********/
        pops: false,
        isFullscreen:false,//是否显示全屏遮罩
        loadingText:"提交中，请稍后.......",
        //repShow:false,
        //*********query
        params: {    //params保存上一次的选择状态 初始为空
          examStartDate: '',
          examEndDate: '',
          serviceModalities: '',
          clinicType: '',
          markCode:'',
          patientName: '',
          searchNum: '',
          readFilmFlag: "",
          hosArea: "",  //院区
          currentPage: ""
        },
        //初始
        totals: 0,   //总条目
        currentPages: 0,
        pageSize: 30,
        allPages: 0,   //总页数
        params_image:{//阅片数据
          hospitalId:'',
          studyPk:'',
          studyUid:'',
        }
      }
    },
    mounted() { //初始化完成加载时间
      this.setTime();
      //完全不理解这里要干嘛
      // http.post('/edu/getMarkDisList.json').then(res => {
      //   if (res.data.code == "SUCCESS") {
      //     //this.data[payload.index].readFilmFlag = "0";
      //   }
      // }).catch(() => {
      // })

      window.addEventListener('resize', () => {
        setTimeout(() => {
          this.getH()
        }, 50)
      });

    },
    methods: {
      getH(){
        this.autoheight = document.body.clientHeight - 50 - 40 - 154 - 15 - 40 - 15 //header + crumb + search + padding + pages + marinbottom
      },
      __pageSize(payload) {
        this.pageSize = payload
        let hosCondition = sessionStorage.getItem('hosCondition');
        let Date = {};
        if(hosCondition!=null){
          hosCondition = JSON.parse(hosCondition);
          Date = {
            fDate:hosCondition.examStartDate,
            aDate:hosCondition.examEndDate
          };
        }
        this.query(Date)
      },
      _operation_(payload) {
        if (payload.operation === 'icon-baogao') {
          if (this.data[payload.index].reportState == '3') {
            this.$router.push({name: "ViewReport"})  //传参
            sessionStorage.setItem('hospitalId', this.data[payload.index].hospitalId);
            sessionStorage.setItem('studyPk', this.data[payload.index].studyPk);
            //sessionStorage.setItem('studyUid', this.data[payload.index].studyUID);
            sessionStorage.setItem('studyUid', this.data[payload.index].studyUid);
            sessionStorage.setItem('mediId', this.data[payload.index].mediId);
            //sessionStorage.setItem('patientType', this.data[payload.index].patientType);
          }
        }
        if (payload.operation === 'icon-yuepian'){
          //if(this.data[payload.index] == '3')
          // let Aycan = {
          //   hospitalId:this.data[payload.index].hospitalId,
          //   studyPk:this.data[payload.index].studyPk,
          //   studyUid:this.data[payload.index].studyUid,
          // }
          this.params_image.hospitalId = this.data[payload.index].hospitalId;
          this.params_image.studyPk = this.data[payload.index].studyPk+"";
          this.params_image.studyUid = this.data[payload.index].studyUid;
          this.$nextTick(() => {
              this.$refs.aycanImages.getConsultImages();
            })

           // Aycan = JSON.stringify(Aycan)  //新窗口请求阅片
           // sessionStorage.setItem('Aycan', Aycan);
           //  let imgData = this.$router.resolve({path:'/ImgView'})
           //  window.open(imgData.href, '_blank')
          // let imgData = this.$router.push({path:'/ImgView',query:{getAycan:Aycan}})

          // http.post('/edu/prepareAycanBenYuan.json', Aycan).then(res => {   //旧窗口请求阅片
          //   if (res.data.code == "0000") {
          //     window.open(res.data.model,'_blank');
          //   }else{
          //     message(res.data.msg,false);
          //   }
          // }).catch(() => {
          // })
        }
        if (payload.operation === 'icon-shoucang') {
          //console.log(this.data[payload.index])
          //console.log(this.data[payload.index].refId==undefined)
          //if (this.data[payload.index].refId == undefined) {
            for(let i in this.CaseInfo){  //清除上一条记录
              if(i=='ageUnit'){
                this.CaseInfo[i]='4';
              }else{
                this.CaseInfo[i]='';
              }
            }
            //获取病历库列表
            this._getTreeData();
            this._getTreeData(1);
            //查询影像所见 诊断结果
            let rep = {
              hospitalId: this.data[payload.index].hospitalId,
              studyPk: this.data[payload.index].studyPk,
              //studyUid: this.data[payload.index].studyUID,
              studyUid: this.data[payload.index].studyUid,
            };
            http.post('/edu/reportDetail.json', rep).then(res => {  //查询影像所见和诊断结果
              if (res.data.code == "0000") {
                if(res.data.model.reportEvidences!=undefined){  //无报告的病例为undefined 要进行判断
                  this.CaseInfo.evidence = res.data.model.reportEvidences;
                }else{
                  this.CaseInfo.evidence = '';  //清空上一次的值（上一次有报告这次无报告）
                }
                if(res.data.model.reportConclusion!=undefined){
                  this.CaseInfo.dianogeResult = res.data.model.reportConclusion;
                }else{
                  this.CaseInfo.dianogeResult = '';
                }
              }
            }).catch(() => {
            });
            if(this.data[payload.index].patientAge!=undefined&&this.data[payload.index].patientAge!=null&&this.data[payload.index].patientAge!=''){ //如果获取到值
              //this.CaseInfo.caseAge = this.data[payload.index].patientAge.substr(0,this.data[payload.index].patientAge.length-1);
              this.CaseInfo.caseAge = parseInt(this.data[payload.index].patientAge)
              if(this.data[payload.index].ageUnit!=undefined){
                this.CaseInfo.ageUnit = this.data[payload.index].ageUnit; //1 2 3 4
              }else{
                this.CaseInfo.ageUnit = "4"
              }
            }else{
              this.CaseInfo.caseAge = ""
              this.CaseInfo.ageUnit = "4"
            }
            this.CaseInfo.caseSex = changeSex(this.data[payload.index].patientSex);    //0 1
            this.CaseInfo.index = payload.index;    //当前操作的报告索引
            this.studyList.hospitalId = this.data[payload.index].hospitalId;
            this.studyList.studyPk = this.data[payload.index].studyPk;
            this.pops = true;
          //} else {
           // this.$alert('该病例已收藏，请到病例库中取消收藏 !', '提示');
          //}
        }
        if (payload.operation === 'icon-dupian') {
          if (this.data[payload.index].readFilmFlag == '0'||this.data[payload.index].readFilmFlag == undefined) {
            this.$confirm('是否确定标记该病例?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
            }).then(() => {
              //****处理
              let params = {
                hospitalId: this.data[payload.index].hospitalId,
                studyPk: this.data[payload.index].studyPk,
                //studyUid: this.data[payload.index].studyUID,
                studyUid: this.data[payload.index].studyUid,
                readFilmFlag:"1",    //标记为0 传1
              };
              http.post('/edu/readFilmFlag.json', params).then(res => {
                if (res.data.code == "0000") {
                  this.data[payload.index].readFilmFlag = "1";
                  //console.log(this.data[payload.index])
                }
              }).catch(() => {
              })
            })
          } else {
            this.$confirm('是否确定要取消标记?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
            }).then(() => {
              //****处理
              let params = {
                hospitalId: this.data[payload.index].hospitalId,
                studyPk: this.data[payload.index].studyPk,
                //studyUid: this.data[payload.index].studyUID,
                studyUid: this.data[payload.index].studyUid,
                readFilmFlag:"0",    //标记为0 传1
              };
              http.post('/edu/readFilmFlag.json', params).then(res => {
                if (res.data.code == "0000") {
                  this.data[payload.index].readFilmFlag = "0";
                }
              }).catch(() => {
              })
            })
          }
          //this.data[payload.index].collection =!this.data[payload.index].collection;
        }
      },
      handleCheckedAllchange(val) {
        this.checkType = val ? [''] : [];
      },
      handleCheckedChange(value) {
        let index = this.checkType.indexOf(String(''));
        if (index != -1) {
          this.checkType.splice(index, 1)
        }
        if (!value) {
          if (this.checkType.length == 0) {
            this.checkType = ['']
          }
        }
      },
      handleDocAllchange(val) {   //true or false
        this.checkDoc = val ? [''] : [];
      },
      handleDocChange(value) {
        let index = this.checkDoc.indexOf(String(''));
        if (index != -1) {
          this.checkDoc.splice(index, 1)
        }
        if (!value) {
          if (this.checkDoc.length == 0) {
            this.checkDoc = ['']
          }
        }
      },
      //收藏病历库
      _getTreeData(privateType = 0, keyWord='', subType) {
        let parmars = {
          privateType,
          keyWord,
          subType
        };
        http.post("/catalog/queryCaseCatalogTree.json", parmars).then(res => {
          if (res.data.code === _.ERR_OK) {
            if (privateType === 0) {
              this.allTreeData = res.data.model;
              this.changeColl('1')
            } else {
              this.oldPersonList = res.data.model;
              this.personList = res.data.model;
            }
          }
        });
      },
      changeColl(playlod) {
        this.defaultTreeChecked = []
        this.filterText = ''
        this.treeData = []
        setTimeout(() => {
        // 1==>部位 2==>诊断 3==>科室
          let [flag, arr] = ['DIANOG', []];
          if (playlod === '1') {
            flag = 'DIANOG';
          } else if (playlod === '2') {
            flag = 'PART';
          } else if (playlod === '3') {
            flag = 'DEPT';
          } else {
            flag = 'CUSTOMER';
          }
          this.treeData = []
          arr = this.allTreeData.filter(item => item.subType === flag)
          for (let item of arr) {
            if (item.parentId === 0) {
              this.treeData.push({
                id: item.id,
                label: item.catalogName,
                children: this.allTreeData.filter(c => c.parentId === item.id)
              })
            }
          }
          for (let item of this.treeData) {
            if (item.children.length > 0) {
              for (let cItem of item.children) {
                cItem.label = cItem.catalogName
              }
            }
          }
        }, 400)
      },
      addPersonList(val) {
        this.$prompt('请输入病例名', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
          // inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
          // inputErrorMessage: '邮箱格式不正确'
        }).then(({ value }) => {
          let parmars = {
            privateType: '1',
            catalogName:　value
          }
          http.post('catalog/addCaseCatalog.json', parmars).then(res => {
            if (res.data.code === _.ERR_OK) {
              this._getTreeData(1);
              this.$message({
                type: 'success',
                message: '提交成功'
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      delPerson(val) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          let parmars = {
            id: val.id
          }
          http.post('catalog/deleteCaseCatalog.json', parmars).then(res => {
            if (res.data.code === _.ERR_OK) {
              this._getTreeData(1);
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      tabChange(payload) {
        //console.log(payload);
        this.filterText = ''
        this.personList = this.oldPersonList
        this.personFlag = payload.name
        this.defaultTreeChecked = []
        this.defaultPersonListChecked = []
        this.personCheckedList =[]
        this.catalogId = []
        if (payload.name === "1") {
          this.isPerson = true;
        } else {
          this.isPerson = false;
        }
      },
      searchClick(val) {
        this.filterText = val
        this.personList = this.oldPersonList.filter(item => item.catalogName.indexOf(val)>-1)
      },
      checkTree(val){ //收藏 子元素的传值
        let idList = [];
        for(let i=0;i<val.length;i++){
          idList.push(val[i].id)
          if(val[i].privateType!=undefined) { //privateType默认为0
            this.privateType = val[i].privateType;
          }
        }
        this.catalogId = idList.join(',');
      },
      personChecked(val) {
        this.personCheckedList = val;
        this.catalogId = this.personCheckedList.join(',');
      },
      CollectRecord(val){ //收藏 子元素的传值
        this.CaseInfo = val;
        //this.data[val.index].refId = 1;
      },
      /*点击收藏*/
      Collect(){

        if(this.catalogId==''){
          message('请选择收藏目录！',false)
          return;
        }
        if(this.CaseInfo.caseName==''){
          message('请填写必填项！',false)
          return;
        }
        this.isFullscreen = true
        let CaseInfo ={
          caseName:this.CaseInfo.caseName ,
          caseSex: this.CaseInfo.caseSex,
          caseAge: this.CaseInfo.caseAge,
          ageUnit: this.CaseInfo.ageUnit,
          remark: this.CaseInfo.remark,
          history: this.CaseInfo.history,
          caseResult: this.CaseInfo.caseResult,
          evidence: this.CaseInfo.evidence,
          dianogeResult: this.CaseInfo.dianogeResult,
          catalogId:this.catalogId,
          privateType:this.personFlag,
          studyList:[
            {hospitalId:this.studyList.hospitalId,
              studyPk:this.studyList.studyPk},
          ]
        };

        http.post('/caselib/addCaseInfo.json', CaseInfo).then(res => {
          if (res.data.code == "SUCCESS") {
            this.pops = false;
            this.isFullscreen = false
            message('收藏成功，请前往病例库中查看！',true)

            //this.data[this.CaseInfo.index].refId = 1;
          }else{
            message(res.data.msg,false)
          }
        }).catch(() => {
        });

      },
      //获取日期
      getDay(day){
        var today = new Date();

        var targetday_milliseconds=today.getTime() + 1000*60*60*24*day;

        today.setTime(targetday_milliseconds); //注意，这行是关键代码

        var tYear = today.getFullYear();
        var tMonth = today.getMonth();
        var tDate = today.getDate();
        tMonth = this.doHandleMonth(tMonth + 1);
        tDate = this.doHandleMonth(tDate);
        return tYear+"-"+tMonth+"-"+tDate;
      },
      doHandleMonth(month){
        var m = month;
        if(month.toString().length == 1){
          m = "0" + month;
        }
        return m;
      },
      setTime() {
        let Date ={};
        if(this.checkDate=='近三天'){
          Date.aDate = this.getDay(0);
          Date.fDate = this.getDay(-3);
        }else if(this.checkDate=='近一周'){
          Date.aDate = this.getDay(0);
          Date.fDate = this.getDay(-7);
        }else if(this.checkDate=='近一月'){
          Date.aDate = this.getDay(0);
          Date.fDate = this.getDay(-31);
        }else if(this.checkDate=='近半年'){
          Date.aDate = this.getDay(0);
          Date.fDate = this.getDay(-180);
        }else if(this.checkDate=='今天'){
          Date.aDate = this.getDay(0);
          Date.fDate = this.getDay(0);
        }else{
          Date.aDate = "";
          Date.fDate = "";
        }
        this.$refs.child.setDate(Date);
      },
      getTime() {
        //this.checkSearchNum();
        this.$refs.child.getDate();
      },
      //开启会议
      linkto(){
        //this.$router.push({name: "DailyMeeting"});
        http.post('/getTokenId.json').then(res => {
          if (res.data.code == "SUCCESS") {
            window.location.href=`${window.tyURL}`+res.data.model.accesstoken+'&redirect=meeting_index'
            // http.post('/logout.json').then(res => {
            //   cookies.delAllCookie()
            // }).catch(err => {
            // })
          }else{
            message(res.data.msg)
          }
        }).catch(() => {
        })
      },

      checkSearchNum(){
        //if(this.checkNumber!=0&&this.checkNumber.length!=8){
          message('未查询到符合条件记录',false);
          return;
        //}
      },
      ResetLable(){
        this.checkDate='';
      },
      reset() {    //重置
        sessionStorage.removeItem('hosCondition')
        this.checkDate = '今天'
        this.checkType = ['']
        this.checkDoc = ['']
        this.checkRead = ''
        this.checkNumber = ''
        this.patientName = ''
        this.hosArea = ''
        this.params = {}
        this.biaoji = []
        //查询后重置
        let Date ={};
        Date.aDate = this.getDay(0);
        Date.fDate = this.getDay(0);
        // console.log(Date)
        this.$refs.child.setDate(Date);
      },
      closePop(val) {
        this.pops = val;
      },
      searchEnterFun(e) {
           let keyCode = window.event? e.keyCode:e.which
           if(keyCode == 13){
              this.getTime()
           }
      },
      query(emitDate) {   //查询列表

        let param = {}
        this.loading = true
       // console.log("开始" +emitDate.fDate + "结束" + emitDate.aDate)
        let readFilmFlags;
        this.checkRead == true ? readFilmFlags = "1" : readFilmFlags = "";

        // console.log(this.checkType)

        param = this.params = {
          examStartDate: emitDate.fDate,
          //examStartDate: this.params.examStartDate ,
           examEndDate: emitDate.aDate,
         //examEndDate:this.params.examEndDate,
         //serviceModalities: this.checkType.join(','),
          serviceModalities: changecheckType(this.checkType).join(','),
          clinicType: this.checkDoc.join(','),
          markCode:this.markCode.join(','),
          patientName: this.patientName,
          searchNum: this.checkNumber,
          readFilmFlag: readFilmFlags,
          hosArea: this.hosArea,  //院区

          //查询列表的currentPage，pageSize默认为空
          currentPage: "",  //当前页
          allPages:this.allPages,
          pageSize: this.pageSize   //一页多少条
        }

        http.post(`/edu/qualityImagesList.json?${Math.random()}`, param).then(res => {
          if(res.data.totalItem==0) {
            this.checkSearchNum();
          }
          this.totals = res.data.totalItem;
          // console.log(res.data)
          if (res.data.code == _.ERR_OK) {
            this.data = [];
            this.loading = false
            for (let i = 0; i < res.data.model.length; i++) {
              res.data.model[i].examDate = nomalTime(res.data.model[i].examDate);
              res.data.model[i].patientSex = changeGender(res.data.model[i].patientSex);
             // res.data.model[i].hospitalName = changehosArea(res.data.model[i].hospitalName);
             res.data.model[i].hospitalName =res.data.model[i].hospitalName;
             res.data.model[i].patientId=res.data.model[i].patientId;
              res.data.model[i].clinicType = changeclinicType(res.data.model[i].clinicType);
             /*  if(res.data.model[i].patientAge!==undefined){
                if(res.data.model[i].patientAge.indexOf("岁") >-1){

                      res.data.model[i].patientAge  = res.data.model[i].patientAge
                }else{
                    res.data.model[i].patientAge = res.data.model[i].patientAge + changeAge(res.data.model[i].ageUnit)
                }
              } else {
                res.data.model[i].patientAge = ''
              } */
               if(res.data.model[i].patientAge!==undefined){
                 res.data.model[i].patientAge  = res.data.model[i].patientAge
               }else{
                   res.data.model[i].patientAge = ''
               }

              this.data.push(res.data.model[i]);
            }
            this.totals = res.data.totalItem
            this.allPages = res.data.totalPages
            this.pageSize = res.data.pageSize
            this.currentPages = res.data.currentPage
            //将筛选条件存入本地
            let hosCondition = {
              hosArea: this.hosArea,    //默认全部院区 不能为空
              examStartDate: this.params.examStartDate,
              examEndDate: this.params.examEndDate,
              checkDate: this.checkDate,
              checkType: this.checkType,
              checkDoc: this.checkDoc,
              markCode:this.markCode,
              checkRead: this.checkRead,
              patientName: this.patientName,
              checkNumber: this.checkNumber,
              biaoji:this.biaoji,
              currentPage: this.currentPages,
              allPages:this.allPages,
              pageSize: this.pageSize,
            };
            hosCondition = JSON.stringify(hosCondition)
            sessionStorage.setItem('hosCondition', hosCondition)
          }else{
            this.loading = false
          }
          //console.log(this.data)
        }).catch(() => {
        })
      },
      pagequery(val) {    //请求table页
        this.params.currentPage = val
        let param=this.params

        http.post('/edu/qualityImagesList.json', param).then(res => {
          if (res.data.code == _.ERR_OK) {
            this.data = [];
            for (let i = 0; i < res.data.model.length; i++) {
              res.data.model[i].examDate = nomalTime(res.data.model[i].examDate)
              res.data.model[i].patientSex = changeGender(res.data.model[i].patientSex)
              //res.data.model[i].hospitalName = res.data.model[i].hospitalName
             //  console.log(res.data.model[i].hospitalName,'llll')
              res.data.model[i].clinicType = changeclinicType(res.data.model[i].clinicType)
          /*      if(res.data.model[i].patientAge!==undefined){
                if(res.data.model[i].patientAge.indexOf("岁") >-1){
                      res.data.model[i].patientAge  = res.data.model[i].patientAge
                }else{
                    res.data.model[i].patientAge = res.data.model[i].patientAge + changeAge(res.data.model[i].ageUnit)
                }
              } else {
                res.data.model[i].patientAge = ''
              } */
            if(res.data.model[i].patientAge!==undefined){
                res.data.model[i].patientAge  = res.data.model[i].patientAge
            }else{
              res.data.model[i].patientAge = ''
            }

              this.data.push(res.data.model[i])
            }
            this.totals = res.data.totalItem
            this.allPages = res.data.totalPages
            this.pageSize = res.data.pageSize
            this.currentPages = res.data.currentPage
            let hosCondition = JSON.parse(sessionStorage.getItem('hosCondition'));
            // hosCondition.currentPage = val
            // [this.params.currentPage,this.params.pageSize,this.allPages] = [hosCondition.currentPage,hosCondition.pageSize,hosCondition.allPages]
            // console.log(hosCondition)
            hosCondition.currentPage = this.currentPages
            sessionStorage.setItem('hosCondition', JSON.stringify(hosCondition))
          }
        }).catch(() => {
        })
      },
      init_Data(){
        this.getH();
        let param;
        if(sessionStorage.getItem('hosCondition')!=null){
          let hosCondition=JSON.parse(sessionStorage.getItem('hosCondition'));
          this.hosArea = hosCondition.hosArea;
          this.params.examStartDate = hosCondition.examStartDate
          this.params.examEndDate = hosCondition.examEndDate
          this.checkDate = hosCondition.checkDate
          this.checkType = hosCondition.checkType
          this.checkDoc = hosCondition.checkDoc
          this.markCode = hosCondition.markCode
          this.checkRead = hosCondition.checkRead
          this.patientName = hosCondition.patientName
          this.checkNumber = hosCondition.checkNumber
          this.biaoji = hosCondition.biaoji
          this.params.currentPage = hosCondition.currentPage
          this.pageSize = hosCondition.pageSize
          this.allPages = hosCondition.allPages
          // console.log()
          let readFilmFlags;
          this.checkRead == true ? readFilmFlags = "1" : readFilmFlags = "";
          param = this.params ={
            examStartDate: this.params.examStartDate,
            examEndDate: this.params.examEndDate,
            serviceModalities: changecheckType(this.checkType).join(','),
            clinicType: this.checkDoc.join(','),
            markCode:this.markCode.join(','),
            patientName: this.patientName,
            searchNum: this.checkNumber,
            readFilmFlag: readFilmFlags,
            hosArea: this.hosArea,  //院区
            //查询列表的currentPage，pageSize默认为空
            currentPage: this.params.currentPage,  //当前页
            allPages: this.allPages,
            pageSize: this.pageSize   //一页多少条
          };
          // console.log(this.params.allPages)
          let Date = {
            fDate:hosCondition.examStartDate,
            aDate:hosCondition.examEndDate
          }
          setTimeout(()=>{this.$refs.child.setDate(Date)},500)
        }else{
          //param.examStartDate = this.getDay(0);
          //param.examEndDate = this.getDay(0);
          param = this.params;
          param.examStartDate = this.getDay(0);
          param.examEndDate = this.getDay(0);
          param.pageSize=30;
        }
        this.loading = true
        http.post('/edu/qualityImagesList.json', param).then(res => {
          if (res.data.code == _.ERR_OK) {
            this.loading = false
            this.data = [];
            for (let i = 0; i < res.data.model.length; i++) {
              res.data.model[i].examDate = nomalTime(res.data.model[i].examDate);
              res.data.model[i].patientSex = changeGender(res.data.model[i].patientSex);
            // res.data.model[i].hosArea = changehosArea(res.data.model[i].hosArea);
              res.data.model[i].hospitalName =res.data.model[i].hospitalName;
              res.data.model[i].clinicType = changeclinicType(res.data.model[i].clinicType);
         /*      if(res.data.model[i].patientAge!==undefined){
                if(res.data.model[i].patientAge.indexOf("岁") >-1){
                      res.data.model[i].patientAge  = res.data.model[i].patientAge
                }else{
                    res.data.model[i].patientAge = res.data.model[i].patientAge + changeAge(res.data.model[i].ageUnit)
                }
              } else {
                res.data.model[i].patientAge = ''
              } */
           if(res.data.model[i].patientAge!==undefined){
               res.data.model[i].patientAge  = res.data.model[i].patientAge
           }else{
                res.data.model[i].patientAge = ''
           }


              this.data.push(res.data.model[i]);
            }
            this.totals = res.data.totalItem
            this.pageSize = res.data.pageSize
            this.allPages = res.data.totalPages
            this.currentPages = res.data.currentPage
          }else{
            this.loading = false
          }
        }).catch((e) => {
         // console.error(e);
        });

        let sandData={
          hosName:''
        }
        http.post('/system/findHosListOfRegion.json', sandData).then(res =>{
          this.hos= res.data.model;
          this.hos.forEach(item => {
              this.hos.item= item.hosId
            })
        })
        }

    },
    watch:{
      checkDate(){
        this.setTime();
      }
    },
    beforeRouteLeave(to, from, next){
      //打开详情页（或者下一个任意界面）之前，把筛选条件保存到localStorage，如果离开列表页并且打开的不是详情页则清除，也可以选择不清除
      if (to.name != 'ViewReport') {
        sessionStorage.removeItem('hosCondition')
      }else{

      }
      next()
    },
    created() {
      this.init_Data();
    },


  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'

  .hospital-select
    width: 98%
    min-width: 980px
    margin: 0 auto
    background: $color-background-d
    padding: 1%
    .s-btn
      display: inline-block
      width: 80px
      height: 28px
      line-height: 28px
      background: $button-base-color
      color: $button-text-color
      text-align: center
      border-radius: 4px
    .open-meeting
      float: right
    .search-box
      float: right
      .reset
        margin-right: 20px
        &:hover
          text-decoration: underline
      .search-btn
        background: $color-background-hover

  .check-time
  .check-type
  .doc-type
  .district-type
    height: 32px
    line-height: 32px
    width: 100%
    color: #000
    em
      font-style: normal
      width: 66px
      height: 32px
      margin-right: 6px
      color: $color-text
      float: left
    > li
      //padding: 0 20px 0 0
      float: left
      label
        cursor: pointer;
        padding: 0 6px
      span
        color:#9d9ea3

  .district-type
    > li
      input[type=checkbox]
        display: inline-block

  .universal
    position: relative
    width: 98%
    min-width: 980px
    margin: auto
    .search
      margin-bottom:15px

  .record
    overflow: hidden

  .record-left
    float: left
    width: 39%

  .record-right
    float: right
    width: 60%

  .shoucang
    display: block
    width: 160px
    height: 30px
    line-height: 30px
    text-align: center
    background: $color-background-hover
    color: $color-background-d
    border-radius: 3px
    margin: 20px auto 0

</style>



// WEBPACK FOOTER //
// hospitalImage.vue?8dce561e